var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ethers } from 'ethers';
export function deriveSymmetricKey(wallet, dkMessage) {
    return __awaiter(this, void 0, Promise, function () {
        var signature, signatureHash, encoder, hashBuffer;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, wallet.signMessage(dkMessage)];
                case 1:
                    signature = _a.sent();
                    signatureHash = ethers.keccak256(signature);
                    encoder = new TextEncoder();
                    return [4 /*yield*/, crypto.subtle.digest('SHA-256', encoder.encode(signatureHash))];
                case 2:
                    hashBuffer = _a.sent();
                    return [2 /*return*/, hashBuffer]; // 32 bytes (256 bits)
            }
        });
    });
}
export function encryptString(symmetricKey, plaintext) {
    return __awaiter(this, void 0, Promise, function () {
        var iv, encoder, data, key, encryptedBuffer, encryptedArrayWithTag, encryptedArray, tag;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    iv = crypto.getRandomValues(new Uint8Array(16)) // Initialization vector (16 bytes for AES-GCM)
                    ;
                    encoder = new TextEncoder();
                    data = encoder.encode(plaintext);
                    return [4 /*yield*/, crypto.subtle.importKey('raw', symmetricKey, { name: 'AES-GCM' }, false, ['encrypt'])];
                case 1:
                    key = _a.sent();
                    return [4 /*yield*/, crypto.subtle.encrypt({
                            name: 'AES-GCM',
                            iv: iv,
                        }, key, data)
                        // Since we don't use crypto lib anymore, we need to retreive tag from ecryptedArray and return them separatly
                    ];
                case 2:
                    encryptedBuffer = _a.sent();
                    encryptedArrayWithTag = new Uint8Array(encryptedBuffer);
                    encryptedArray = encryptedArrayWithTag.slice(0, encryptedArrayWithTag.length - 16);
                    tag = new Uint8Array(encryptedBuffer, encryptedBuffer.byteLength - 16, 16) // Last 16 bytes are the tag
                    ;
                    return [2 /*return*/, {
                            encrypted: Array.from(encryptedArray)
                                .map(function (b) { return b.toString(16).padStart(2, '0'); })
                                .join(''), // Convert to hex string
                            iv: Array.from(iv)
                                .map(function (b) { return b.toString(16).padStart(2, '0'); })
                                .join(''), // Convert to hex string
                            tag: Array.from(tag)
                                .map(function (b) { return b.toString(16).padStart(2, '0'); })
                                .join(''), // Convert to hex string
                        }];
            }
        });
    });
}
export function decryptString(symmetricKey, encrypted, iv, tag) {
    return __awaiter(this, void 0, Promise, function () {
        var encryptedBytes, ivBytes, tagBytes, combinedBytes, key, decryptedBuffer, decoder;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!encrypted) {
                        throw new Error('Encrypted string cannot be null or empty.');
                    }
                    if (!iv) {
                        throw new Error('IV string cannot be null or empty.');
                    }
                    if (!tag) {
                        throw new Error('Tag string cannot be null or empty.');
                    }
                    encryptedBytes = new Uint8Array(encrypted.match(/.{1,2}/g).map(function (byte) { return parseInt(byte, 16); }));
                    ivBytes = new Uint8Array(iv.match(/.{1,2}/g).map(function (byte) { return parseInt(byte, 16); }));
                    tagBytes = new Uint8Array(tag.match(/.{1,2}/g).map(function (byte) { return parseInt(byte, 16); }));
                    // Check if the input byte arrays are valid
                    if (encryptedBytes.length === 0 || ivBytes.length === 0 || tagBytes.length === 0) {
                        throw new Error('Invalid input: encrypted, iv, or tag cannot be empty.');
                    }
                    combinedBytes = new Uint8Array(encryptedBytes.length + tagBytes.length);
                    combinedBytes.set(encryptedBytes);
                    combinedBytes.set(tagBytes, encryptedBytes.length);
                    return [4 /*yield*/, crypto.subtle.importKey('raw', symmetricKey, { name: 'AES-GCM' }, false, ['decrypt'])];
                case 1:
                    key = _a.sent();
                    return [4 /*yield*/, crypto.subtle.decrypt({
                            name: 'AES-GCM',
                            iv: ivBytes,
                        }, key, combinedBytes)
                        // Ensure decryptedBuffer is valid
                    ];
                case 2:
                    decryptedBuffer = _a.sent();
                    // Ensure decryptedBuffer is valid
                    if (!decryptedBuffer) {
                        throw new Error('Decryption failed: buffer is null.');
                    }
                    decoder = new TextDecoder();
                    return [2 /*return*/, decoder.decode(decryptedBuffer)];
            }
        });
    });
}
